import {
    Modal,
    ModalHeader,
    ModalBody,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";

import classNames from "classnames";
import { useState } from "react";

import InlineLoginForm from "../InlineLoginForm";
import InlineRegisterForm from "../InlineRegisterForm";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onLoginSuccess: () => void;
    onRegisterSuccess: () => void;
    defaultTab?: "login" | "register";
}

const AuthModal = ({
    isOpen,
    toggle,
    onLoginSuccess,
    onRegisterSuccess,
    defaultTab = "register"
}: Props) => {

    const [activeTab, setActiveTab] =
        useState(defaultTab);

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            size="lg"
            
        >

            <ModalHeader toggle={toggle}>
                Welcome to PriceWorth
            </ModalHeader>

            <ModalBody>

                <Nav tabs>

                    <NavItem>

                        <NavLink
                            className={classNames({
                                active: activeTab === "login"
                            })}
                            onClick={() => setActiveTab("login")}
                            style={{ cursor: "pointer" }}
                        >
                            Login
                        </NavLink>

                    </NavItem>

                    <NavItem>

                        <NavLink
                            className={classNames({
                                active: activeTab === "register"
                            })}
                            onClick={() => setActiveTab("register")}
                            style={ { cursor: "pointer" }}
                        >
                            Create Account
                        </NavLink>

                    </NavItem>

                </Nav>

                <div className="mt-4">

                    {activeTab === "login" ? (

                        <InlineLoginForm
                            inline={false}
                            onLoginSuccess={() => {
                                toggle();
                                onLoginSuccess();
                            }}
                        />

                    ) : (

                        <InlineRegisterForm
                            inline={false}
                            onRegisterSuccess={() => {
                                setActiveTab("login");
                                onRegisterSuccess();
                            }}
                        />

                    )}

                </div>

            </ModalBody>

        </Modal>

    );

};

export default AuthModal;